module.exports = __webpack_public_path__ + "static/img/4.dd14d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/objectRecognition/unity/4.png
// module id = MX9q
// module chunks = 1